exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sub-header {\n  font-size: 1.125rem;\n  margin-bottom: 1rem;\n}\n.divider {\n  margin: 1rem 0;\n}\n.csv-link {\n  cursor: pointer;\n}\n.no-tickets-message {\n  font-weight: bold;\n}\n", ""]);

// exports
